import { useTranslation } from 'react-i18next';
import { useGateways } from '../../data/hooks';
import { Card, PageHeader, PresenceBadge } from '../../ui/components';
import { formatNumber, formatRelative } from '../../ui/format';

export function GatewaysPage() {
  const { t } = useTranslation();
  const gws = useGateways();
  return (
    <div className="page">
      <PageHeader title={t('gateways.title')} />
      <Card bodyClass="" title={t('gateways.title')}>
        <div style={{ overflowX: 'auto' }}>
          <table className="table">
            <thead>
              <tr>
                <th>{t('common.name')}</th>
                <th>Key</th>
                <th>{t('gateways.kind')}</th>
                <th>{t('common.status')}</th>
                <th>{t('gateways.version')}</th>
                <th className="num">{t('gateways.connected')}</th>
                <th>{t('gateways.lastSeen')}</th>
              </tr>
            </thead>
            <tbody>
              {(gws.data ?? []).map((g) => (
                <tr key={g.id}>
                  <td>{g.name}</td>
                  <td className="mono">{g.key}</td>
                  <td>{g.kind}</td>
                  <td>
                    <PresenceBadge
                      presence={
                        g.status === 'online' ? 'online' : g.status === 'offline' ? 'offline' : 'unknown'
                      }
                    />
                  </td>
                  <td className="mono">{g.softwareVersion}</td>
                  <td className="num">{formatNumber(g.connectedDevices)}</td>
                  <td className="muted">{formatRelative(g.lastSeenAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
